<template>
  <div id="app">
    <div v-if="isAuthenticated">
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand to="/">BI Backoffice</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item v-if="isInRole('SmartGrabberUser')" to="/smartgrabber"
              >SmartGrabber
            </b-nav-item>
            <b-nav-item v-if="isInRole('GbqUser')" to="/big-query-grabber"
              >Big Query
            </b-nav-item>
            <b-nav-item v-if="isInRole('TableauUser')" :to="{ name: 'Reports' }"
              >Tableau Views
            </b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown
              v-if="user.isAdmin || isInRole('TableauAdmin')"
              class="mr-5"
            >
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                <span>Administrator</span>
              </template>
              <b-dropdown-item to="/users" v-if="user.isAdmin"
                >User Management
              </b-dropdown-item>
              <!--              <b-dropdown-item to="/trustedips" v-if="user.isAdmin"-->
              <!--                >Setup Trusted IPs</b-dropdown-item-->
              <!--              >-->
              <section>
                <b-dropdown-item
                  to="/admin/tableau-management"
                  v-if="user.isAdmin"
                  >Settings
                </b-dropdown-item>
              </section>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown v-if="user.isAuthenticated" right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                <em>{{ user.name }}</em>
              </template>
              <b-dropdown-item href="#" @click="signOut">
                <span>Logout</span>
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item v-else href="/identity/account/login">Login</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <b-container fluid>
        <router-view />
      </b-container>
    </div>
    <div v-else>
      <login-page />
    </div>
    <b-modal
      v-model="signOutModal"
      centered
      hide-header
      ok-only
      ok-title="Done"
      button-size="sm"
    >
      <p>
        Logged out from BIBO. Do you want to logout the account from your
        browser?
      </p>
      <b-button variant="outline-primary" size="sm" @click="signOutAll">
        Logout from Browser
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import application from '@/mixins/application';
import msalAuth from './services/msalAuth';
import loginPage from './views/LoginPage.vue';

export default {
  mixins: [application],
  components: { loginPage },
  mounted() {
    if (!this.isAuthenticated) {
      msalAuth.getTokenPopup();
    }
  },
  data() {
    return {
      signOutModal: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.state.user.isAuthenticated;
    },
  },
  methods: {
    signOut() {
      this.$store.commit('updateUser', { isAuthenticated: false });
      this.$store.commit('updateToken', null);
      localStorage.clear();
      this.signOutModal = true;
    },
    signOutAll() {
      msalAuth.signOut();
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  white-space: nowrap;
  line-height: 60px;
}

.account-warning {
  max-width: 360px;
  position: fixed !important;
  top: 6em;
  right: 1em;
}
</style>
